// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productListStyles } from "@pace/Overrides/Widgets/OrderApprovalDetails/OrderApprovalDetailsProductList";
import { getSystemColor, xScreen } from "@pace/XDL/Utilities";
import { css } from "styled-components";

productListStyles.cartLinesHeaderStyle = {
    wrapper: {
        css: css`
            grid-template-columns:
                91px minmax(0, 600px) minmax(0, 143px) minmax(0, 138px) minmax(0, 111px) minmax(0, 135px)
                minmax(0, 12px);
            @media print {
                break-inside: avoid;
                page-break-inside: avoid;
            }
        `,
    },
    availability: {
        css: css`
            display: none;
        `,
    },
    itemDescription: {
        css: css`
            grid-column: 1 / 4;
            @media print {
                grid-column: 1 / 4;
                display: block;
            }
        `,
    },
    priceUnit: {
        css: css`
            grid-column: 4 / 5;
            @media print {
                grid-column: 4 / 5;
                display: block;
            }
        `,
    },
    qty: {
        css: css`
            grid-column: 5 / 6;
            @media print {
                grid-column: 5 / 6;
                display: block;
            }
        `,
    },
    total: {
        css: css`
            grid-column: 6 / 7;
            border-right: none;
            @media print {
                grid-column: 6 / 7;
                display: block;
            }
        `,
    },
};
productListStyles.orderLinesList = {
    sectionWrapper: {
        css: css`
            ${({ isCondensed }: any) =>
                isCondensed ? ` border-radius: 4px; border: 1px solid ${getSystemColor("common.border")};` : ""};
        `,
    },
    cardExpanded: {
        cartLineContainer: {
            container: {
                css: css`
                    display: grid;
                    grid-template-columns:
                        91px minmax(0, 600px) minmax(0, 143px) minmax(0, 138px) minmax(0, 111px) minmax(0, 135px)
                        minmax(0, 12px);
                    @media print {
                        break-inside: avoid;
                    }
                `,
            },
            availability: {
                css: css`
                    display: none;
                `,
            },
            description: {
                css: css`
                    grid-column: 2 / 4;
                `,
            },
            qty: {
                css: css`
                    padding-top: 6px;
                `,
            },
            price: {
                css: css`
                    ${xScreen("lte", "md")} {
                        grid-column: 1/ 4;
                    }
                `,
            },
        },
    },
    cardCondensed: {
        mainContainer: {
            css: css`
                @media print {
                    break-inside: avoid;
                    page-break-inside: avoid;
                }
            `,
        },
        price: {
            priceLabelText: {
                css: css`
                    @media print {
                        &&& {
                            display: none;
                        }
                    }
                `,
            },
        },
        priceHeadingAndText: {
            heading: {
                css: css`
                    @media print {
                        &&& {
                            display: none;
                        }
                    }
                `,
            },
        },
        extendedUnitNetPrice: {
            heading: {
                css: css`
                    @media print {
                        &&& {
                            display: none;
                        }
                    }
                `,
            },
        },
        productDescriptionContainer: {
            css: css`
                @media print {
                    break-inside: avoid;
                    page-break-inside: avoid;
                }
            `,
        },
        quantity: {
            readOnlyQuantityText: {
                qtyLabelNotEditable: {
                    css: css`
                        @media print {
                            &&& {
                                display: none;
                            }
                        }
                    `,
                },
            },
        },
    },
};
